import { Component, OnInit, Input } from '@angular/core';
import { ShowsService } from '../shows.service';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { FranchisesService } from '../franchises.service';
import { Router } from '@angular/router';
import { ApiFranchise, ApiShow } from '@tytapp/api';

interface State {
    allShows: ApiShow[];
    franchises: ApiFranchise[];
    audioShows: ApiShow[];
    popularShows: ApiShow[];
}

const STATE_KEY = makeStateKey<State>('shows-sidebar');

@Component({
    selector: 'tyt-shows-sidebar',
    templateUrl: './shows-sidebar.component.html',
    styleUrls: ['./shows-sidebar.component.scss']
})
export class ShowsSidebarComponent implements OnInit {

    constructor(
        private showsService: ShowsService,
        private router: Router,
        private franchisesService: FranchisesService,
        private transferState: TransferState
    ) { }

    @Input()
    public title: string;

    allShows: ApiShow[];
    popularShows: ApiShow[];
    audioShows: ApiShow[];
    franchises: ApiFranchise[];
    _showAll: boolean = false;

    get showAll() {
        return this._showAll;
    }

    set showAll(value: boolean) {
        this._showAll = value;
    }

    reset() {
        this.showAll = false;
    }

    async ngOnInit() {

        let savedState = this.transferState.get(STATE_KEY, null);

        if (savedState) {
            Object.assign(this, savedState);
        } else {
            this.allShows = (await this.showsService.all()).filter(x => !x.is_past_show);
            this.franchises = await this.franchisesService.all();

            if (this.allShows) {
                let showPool = this.allShows.slice();

                this.allShows = this.allShows.sort((a, b) => a.name == b.name ? 0 : (a.name > b.name ? 1 : -1));
                this.audioShows = showPool.filter(x => !x.enable_clips && !x.enable_vod && x.enable_podcasting);
                this.popularShows = showPool.slice(0, 7);
            }

            if (this.franchises) {
                this.franchises = this.franchises.filter((franchise) => franchise.article_enabled);
                this.franchises = this.franchises.sort((a, b) => a.web_stories_order - b.web_stories_order);
            }

            this.transferState.set(STATE_KEY, {
                allShows: this.allShows,
                franchises: this.franchises,
                audioShows: this.audioShows,
                popularShows: this.popularShows
            });
        }
    }
}
